var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"video-tutorial-modal",attrs:{"centered":"","size":"lg","hide-footer":""}},[_c('b-container',[_c('b-row',[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.link,"allowfullscreen":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }